/* FV通過後に表示。ただし取り外し動画の再生中は隠す。 */
(() => {
  const bar = document.querySelector('[data-mce-sticky-buy]');
  if (!bar) return;
  let hero, observer, resizeObserver;
  const powerVideoSelector = '[data-mce-power-motion] video[data-mce-intro]';
  const update = () => {
    const powerPlaying = [...document.querySelectorAll(powerVideoSelector)]
      .some(video => !video.paused && !video.ended && !video.error);
    const visible = !!hero?.isConnected && hero.getBoundingClientRect().bottom <= 0 && !powerPlaying && document.documentElement.dataset.mceGalleryFocus !== 'true';
    bar.classList.toggle('is-visible', visible);
    bar.inert = !visible;
    bar.setAttribute('aria-hidden', String(!visible));
  };
  const mount = () => {
    observer?.disconnect();
    resizeObserver?.disconnect();
    // FVが無い商品ページ（2026-10-09〜）は、上部の商品カードの購入ボタンを通過したら出す。
    // 2026-10-16: カートに入れるボタンが完全に画面外へ出てから出す。
    hero = document.querySelector('.main-product-atc') || document.querySelector('[data-mce-scene]') || document.querySelector('[data-mce-sticky-anchor]');
    update();
    if (!hero) return;
    observer = new IntersectionObserver(update, { threshold: 0 });
    observer.observe(hero);
    resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(hero);
  };
  mount();
  // 動画イベントはバブルしないためcaptureで受け、セクション再読込にも対応する。
  ['play', 'playing', 'pause', 'ended', 'emptied', 'error'].forEach(type => {
    document.addEventListener(type, event => {
      if (event.target.matches?.(powerVideoSelector)) update();
    }, true);
  });
  document.addEventListener('mce:gallery-focus', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('resize', update, { passive: true });
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    if (!hero || !event.target.contains(hero)) return;
    observer?.disconnect();
    resizeObserver?.disconnect();
    hero = null;
    update();
  });
})();
